<template>
  <div class="addressList">
  <van-field
  readonly
  clickable
  :label="label"
  :value="selectCity"
  :placeholder="placeholder"
  @click="openSelect"
/>

  <van-popup v-model="showPicker" position="bottom">
    <van-picker :columns="columns"  @change="onChange" 
       show-toolbar
        @cancel="onCancel"
        @confirm="onConfirm"
        confirm-button-text="确认"
        ref="picker"
         :default-index="defaultProvinceIndex"
       />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'addressList',
  //用于数据初始化
  created:function(){
      let defaultCityIndex = 2;
      let defaultProvinceName = '广东省';

      this.$axios.post('/api/v1/user/addressList',{})
        .then(resp => {
          if(resp.code==0){
              this.addressArr = resp.data;
              let columns = this.columns;
              let citys = this.citys;
                let provinceIndex = 0;
                for(let i=0;i<this.addressArr.length;i++){
                    let province = this.addressArr[i];
                    if(province.areaLevel==1){
                      citys[province.name] = [];
                                     
                      for(let j=0;j<this.addressArr.length;j++){
                          let city = this.addressArr[j];
                          if(city.areaLevel==2 && city.parentId==province.id){
                            citys[province.name].push(city.name);

                            if(this.cityId==city.id){
                              defaultProvinceName=province.name;
                              defaultCityIndex=citys[province.name].length-1;
                              this.defaultProvinceIndex=provinceIndex;
                            }
                          }
                      }

                      provinceIndex++;
                    }
                }

                //vant坑逼bug
                if(defaultCityIndex==0){
                    defaultCityIndex =-1;
                }
                console.info("defaultProvinceName===",defaultProvinceName)
                console.info("defaultCityIndex===",defaultCityIndex)
                
                let keyObj = {};
                keyObj.values = Object.keys(citys);
                columns.push(keyObj);

                let valueObj = {};
                valueObj.values = citys[defaultProvinceName];
                valueObj.defaultIndex=defaultCityIndex;

                columns.push(valueObj);

              //回显
              this.setCityId(this.cityId);

          }else{
                Toast(resp.msg);
          }
        });
    
    
  },
  data () {
    return {
      columns: [],
      citys:{},
      selectCity: null,
      defaultIndex:null,
      showPicker: false,
      city:null,
      province:null,
      currentIndex:null,
      addressArr:null,
      defaultProvinceIndex:18,
    }
  },
  props:{
    label:"",
    placeholder:"",
    cityId:null,
  },
  methods:{
    onChange: function(picker, values){
      console.info("values===",values)
      picker.setColumnValues(1, this.citys[values[0]]);
    },
    onConfirm(selectCity, index) {
      console.info("------------------------");
      console.info("selectCity=",selectCity)
      console.info("index=",index)
      this.currentIndex = index;

      var selectData = {};
      for(var i=0;i<this.addressArr.length;i++){
        var province = this.addressArr[i]; 
        if(province.areaLevel==1&&province.name==selectCity[0]){
          selectData.province=province;
          this.selectCity=province.name;
          break;
        }
      }

      if(selectCity[1]){
      for(var i=0;i<this.addressArr.length;i++){
        var city = this.addressArr[i]; 
        if(city.areaLevel==2&&city.name==selectCity[1]){
          selectData.city=city;
          break;
        }
      }
        this.selectCity += ' - ' + selectCity[1];
      }
      
      this.showPicker = false;
      this.$emit("onSelectCity",selectData);
      console.info("selectData",selectData);
    },
    onCancel() {
      this.showPicker = false;
    },
    /**
     * 展示选择框
     */
    openSelect(){
      this.showPicker = true;
      //选择默认选项
      console.info("xxxxxxx");
      
    },
    setCityId(cityId){
      if(this.addressArr){
                for(let i=0;i<this.addressArr.length;i++){
                    let province = this.addressArr[i];
                    if(province.areaLevel==1){           
                      for(let j=0;j<this.addressArr.length;j++){
                          let city = this.addressArr[j];
                          if(city.areaLevel==2 && city.parentId==province.id){
                            if(cityId==city.id){
                              this.city=city;
                              this.province=province;
                              this.onConfirm([province.name, city.name],[i, j]);
                              break;
                            }
                          }
                      }
                      
                    }
                }
              }
    },
  },
  watch:{
    cityId(cityId){
      console.info("cityId改变",cityId);
      console.info("this.addressArr",this.addressArr);
      this.setCityId(cityId);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/component/addressList.vue